import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
const { useState, useEffect, useRef } = React;
import { Paper, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { faClosedCaptioning } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '@mui/material/Tooltip';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { v4 as uuidv4 } from "uuid";
import estilos from "./PanelInformacionPredio.module.css"

const style = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    height: 400,
    bgcolor: 'background.paper',
    border: 'px solid #000',
    boxShadow: 24,
    p: 4,
    color: 'black',
    'overflowY': 'scroll',
};
const ModalDetalleHistorico = (props) => {


    let texto = props.texto
    const { api = undefined } = props
    const { VerModalDetalle, dataDetalle, detalle = undefined } = api
    let rows = []
    useEffect(() => {
        for (const i in dataDetalle) {
            let { ...datos } = dataDetalle[i]
            datos.id = uuidv4()
            rows.push(datos)
        }
    }, [dataDetalle]);
    /******Modal */
    const [openModal, setOpenModal] = React.useState(detalle);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')

    let columns = [
        {
            field: 'magueydescontado', headerName: 'Maguey Descontado', headerAlign: 'center', width: 200, sortable: false,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.magueydescontado}`} arrow>
                        <label>{`${params.row.magueydescontado} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'fechacambio', headerName: 'Fecha de cambio', headerAlign: 'center', width: 200, sortable: false,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.fechacambio.substring(0, 10)}`} arrow>
                        <label>{`${params.row.fechacambio.substring(0, 10)} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'identificador', headerName: 'Identificador Guia', headerAlign: 'center', width: 200,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.identificador}`} arrow>
                        <label>{`${params.row.identificador} `}</label>
                    </Tooltip>
                </div>
            )
        },
    ]
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        VerModalDetalle(false)
        //resetValores({ validacion: false, texto: '' })
    }

    return (
        <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description" hideBackdrop={true} >
            <Box sx={style}>
               <h4 className={`${estilos.labelEspecial} text-center `}>
                    Historico
                </h4>
                <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'center' }}>
                    <Fragment>
                        <div className='row justify-content-center'>
                            <div className='col-12'>
                                <div style={{ height: 250, width: '100%', color: 'black' }}>
                                    <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        disableColumnMenu
                                        sx={{
                                            boxShadow: 0,
                                            color: 'black',
                                            border: 0,
                                            '& .MuiDataGrid-cell': {
                                                display: 'block',
                                                position: 'relative',
                                                textAlign: 'center',
                                            },
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </Fragment>
                </Typography>
                <br />
                <div className='text-center'>
                    <button className={`btn btn-success`} type='button' style={{ width: '50%' }} onClick={() => handleCloseModal()}>Cerrar</button>
                </div>
            </Box>
        </Modal>
    )
};

export default withRouter(ModalDetalleHistorico)
